import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useMemo } from 'react';
import { useWatch } from 'react-hook-form';

import { COMMON_DATETIME_FORMATS } from 'reservations/base/helpers/datetime';
import { getNumberOfGuests } from 'reservations/booking/helpers';
import { FormHeader } from 'reservations/form/components/FormHeader';

const CompleteYourReservation = () => {
  const [date, availability, partySize] = useWatch({
    name: ['date', 'availability', 'partySize']
  });
  const formattedDate = useMemo(
    () => COMMON_DATETIME_FORMATS.dayDateOnly(date),
    [date]
  );

  return (
    <Box>
      <FormHeader />
      <Typography sx={{ fontWeight: 500, fontSize: '16px', mt: '8px' }}>
        {formattedDate} at {availability}
      </Typography>
      <Typography sx={{ fontWeight: 500, fontSize: '16px' }}>
        {getNumberOfGuests(partySize)}
      </Typography>
    </Box>
  );
};

export default CompleteYourReservation;
